<template>
    <div class="mian_page">
        <div class="desktop-element">
            <div class="page_news flex-col">
                <my-menu class="sticky-menu" :default-active-index="3"></my-menu>
                <div class="group_41 flex-row">
                    <div class="block_18 flex-col">

                        <div class="box_2 flex-col" :style="{ backgroundImage: `url(${bannerImage})` }">
                            <div class="text-group_50 flex-col justify-between">
                                <span class="text_124">新闻动态</span>
                                <span class="text_125">News&nbsp;releases</span>
                            </div>
                        </div>
                        <div class="box_43 flex-row justify-between">
                            <div class="text-wrapper_3 flex-col"
                                 :class="{ 'active': selectIndex === 0 }"
                                 @mouseover="hoverIndexFun(0) "
                                 @mouseleave="offhoverIndexFun(0)"
                                 @click="selectCategory('全部',null)"
                            ><span class="text_11">全部新闻</span></div>
                            <div class="text-wrapper_3 flex-col"
                                 :class="{ 'active': selectIndex === 1 }"
                                 @mouseover="hoverIndexFun(1) "
                                 @mouseleave="offhoverIndexFun(1)"
                                 @click="selectCategory('康柏动态',1)"
                            ><span class="text_11">康柏动态</span></div>
                            <div class="text-wrapper_3 flex-col"
                                 @mouseover="hoverIndexFun(2) "
                                 @mouseleave="offhoverIndexFun(2)"
                                 :class="{ 'active': selectIndex === 2 }"
                                 @click="selectCategory('行业观察',2)"
                            ><span class="text_11">行业观察</span></div>
                        </div>

                        <div
                                class="box_45 flex-row justify-between"
                                v-for="(news, index) in newsList"
                                :key="index"
                                @click="goToDetail(news)"
                        >
                            <div class="section_2 flex-col"
                                 :style="{ backgroundImage: `url(${news.pic})` }"
                            ></div>
                            <div class="section_3 flex-col">
                                <span class="text_15">{{ news.title }}</span>
                                <span class="text_14">{{ news.publishTime }}</span>
                                <div class="image-text_74 flex-row justify-between">
                                    <span class="text-group_4" @click.stop="goToDetail(news)">查看更多</span>
                                    <img
                                            class="thumbnail_2"
                                            referrerpolicy="no-referrer"
                                            src="../../assets/news/news_icon_arr3.png"
                                    />
                                </div>
                            </div>
                        </div>

                        <!--分页-->

                        <div class="box_14 flex-row">
                            <!-- 左箭头 -->
                            <div class="image-wrapper flex-col" :class="currentPage > 1 ? 'image-wrapper_2' : 'image-wrapper_1'"
                                 @click="currentPage > 1 && prevPage()">
                                <img class="thumbnail_7" src="../../assets/news/news_icon_arr1.png" />
                            </div>

                            <!-- 分页数字 -->
                            <template v-for="(page, index) in displayedPages">
                                <div
                                        v-if="page === '...'"
                                        :key="'ellipsis' + index"
                                        class="text_28"
                                >...</div>
                                <div
                                        v-else
                                        :key="page"
                                        class="text-wrapper_5 flex-col"
                                        :class="{ 'active-page': page === currentPage }"
                                        @click="goToPage(page)"
                                >
                                    <span class="text_25">{{ page }}</span>
                                </div>
                            </template>

                            <!-- 右箭头 -->
                            <div class="image-wrapper flex-col" :class="currentPage < totalPages ? 'image-wrapper_2' : 'image-wrapper_1'"
                                 @click="currentPage < totalPages && nextPage()">
                                <img class="thumbnail_8" src="../../assets/news/news_icon_arr2.png" />
                            </div>
                        </div>


                    </div>
                </div>
                <ChpcFooter></ChpcFooter>
                <contact-float v-show="isVisible" @change="change" />
                <contact-dialog v-show="!isVisible" @showContact="showContact"></contact-dialog>
            </div>
        </div>
        <div class="mobile-element">
            <div class="mobile-page flex-col">
                <mobile-header class="sticky-menu-mobile" :default-active-index="3"></mobile-header>
                <div class="mobile-link">
                    <mobile-link :default-active-index="3"></mobile-link>
                    <mobile-banner :contactBanner="bannerImage"></mobile-banner>
                    <!--type-->
                    <div class="box_43_mobile flex-row">
                        <div class="text-wrapper_3_mobile flex-col"
                             :class="{ 'active': selectIndex === 0 }"
                             @mouseover="hoverIndexFun(0) "
                             @mouseleave="offhoverIndexFun(0)"
                             @click="selectCategory('全部',null)"
                        ><span class="text_11_mobile">全部新闻</span></div>
                        <div class="text-wrapper_3_mobile flex-col"
                             :class="{ 'active': selectIndex === 1 }"
                             @mouseover="hoverIndexFun(1) "
                             @mouseleave="offhoverIndexFun(1)"
                             @click="selectCategory('康柏动态',1)"
                        ><span class="text_11_mobile">康柏动态</span></div>
                        <div class="text-wrapper_3_mobile flex-col"
                             @mouseover="hoverIndexFun(2) "
                             @mouseleave="offhoverIndexFun(2)"
                             :class="{ 'active': selectIndex === 2 }"
                             @click="selectCategory('行业观察',2)"
                        ><span class="text_11_mobile">行业观察</span></div>
                    </div>
                    <mobile-list :type="1"></mobile-list>
                </div>
                <mobile-footer @contactMobile="contactMobile"></mobile-footer>
                <mobile-contact-dialog v-show="isVisibleMobile" @closeMobileContact="closeMobileContact"></mobile-contact-dialog>

            </div>
        </div>
    </div>
</template>
<script>
    import myMenu from "@/views/Component/ChpcMenu.vue";
    import ChpcFooter from "@/views/Component/ChpcFooter";
    import {formartDate} from "../../common/testFun";
    import ContactFloat from "@/views/Component/Contact.vue";
    import ContactDialog from "@/views/Component/ContactDialog";
    //mobile
    import MobileHeader from "@/views/Component/MobileHeader";
    import MobileLink from "@/views/Component/MobileLink";
    import MobileFooter from "@/views/Component/MobileFooter";
    import MobileBanner from "./childPage/MobileBanner";
    import MobileList from "./childPage/MobileList";
    import MobileContactDialog from "@/views/Component/MobileContactDialog";
    export default {
        name: "dynamicsIndex",
        metaInfo:{
            title:'北京康柏汉森医药科技咨询有限责任公司',
            meta:[{name: 'keyWords', content:'官网，CHPC，医药咨询，康柏汉森，医药科技咨询；医药企业营销咨询；企业管理咨询；商务咨询'},
                {name:'description', content:'简称CHPC, CHPC起步于医药行业,中国医药行业内风险控制领域的服务提供商，提供渠道核查、合规核查、信息技术、管理咨询服务'},
                {name:"robots",content:"北京康柏汉森医动态"},
            ]
        },
        data() {
            return {
                isVisible:true,  //显示联系浮窗
                isVisibleMobile:false,
                bannerImage: require("../../assets/news/news_banner_01.png"),
                type:1,
                totalCount:0,
                selectedCategory: '康柏动态', // 默认选中"全部新闻"
                currentPage: 1,
                pageSize: 6, // 每页显示5条新闻
                maxVisiblePages: 6, // 最多显示5个页码
                newsList: [],
                selectIndex:1,
                hoverIndex:-1,

            };
        },
        //
        components:{
            myMenu,ChpcFooter,ContactDialog,ContactFloat,
            MobileHeader,MobileLink,MobileFooter,MobileBanner,MobileList,MobileContactDialog
        },
        computed: {
            filteredNews() {
                if (this.selectedCategory === '全部') {
                    return this.newsList;
                }
                return this.newsList.filter(item => item.category === this.selectedCategory);
            },
            totalPages() {
                return Math.ceil(this.totalCount / this.pageSize);
            },
            paginatedNews() {
                const start = (this.currentPage - 1) * this.pageSize;
                const end = start + this.pageSize;
                return this.newsList.slice(start, end);
            },
            displayedPages() {
                const range = [];
                let start = Math.max(
                    1,
                    this.currentPage - Math.floor(this.maxVisiblePages / 2)
                );
                let end = Math.min(
                    this.totalPages,
                    start + this.maxVisiblePages - 1
                );

                if (end - start < this.maxVisiblePages - 1) {
                    start = Math.max(1, end - this.maxVisiblePages + 1);
                }

                // 添加首尾页码
                if (start > 1) {
                    range.push(1);
                    if (start > 2) range.push('...');
                }

                for (let i = start; i <= end; i++) {
                    range.push(i);
                }

                if (end < this.totalPages) {
                    if (end < this.totalPages - 1) range.push('...');
                    range.push(this.totalPages);
                }

                return range;
            }
        },
        mounted() {
            let mypage =  this.$route.query.page;
            if(mypage){
                this.pageNum = mypage;
            }
            this.getInfo();
        },
        methods: {
            change(){
                this.isVisible = false;
            },
            showContact(){
                this.isVisible = true;
            },
            contactMobile(){
                this.isVisibleMobile = true;
            },
            closeMobileContact(){
                this.isVisibleMobile = false;
            },
            // 新增分类切换方法
            selectCategory(category,type) {
                let url = 'Information';
                if(type === null){
                    url = 'Information';
                }else if(type === 1){
                    url = 'dynamics';
                }else if(type === 2){
                    url = 'observation';
                }
                this.$router.push(url, () => {
                    // 导航完成后滚动到顶部
                    window.scrollTo(0, 0);
                }, (error) => {
                    // 可选：处理导航失败的情况
                    console.error('导航失败:', error);
                });
            },
            hoverIndexFun(index){
                this.hoverIndex = index;
                this.selectIndex = index;
            },
            offhoverIndexFun(index){
                if(this.selectedCategory== '全部'){
                    this.selectIndex = 0 ;
                }else if(this.selectedCategory== '康柏动态'){
                    this.selectIndex = 1 ;
                }else if(this.selectedCategory== '行业观察'){
                    this.selectIndex = 2 ;
                }

                this.hoverIndex = -1;
            },
            goToPage(page) {
                if (page === '...' || page === this.currentPage) return;
                this.currentPage = page;
                this.getInfo(); // 切换页码时重新获取数据
            },
            prevPage() {
                if (this.currentPage > 1) {
                    this.currentPage--;
                    this.getInfo();
                }
            },
            nextPage() {
                if (this.currentPage < this.totalPages) {
                    this.currentPage++;
                    this.getInfo();
                }
            },
            // 实现两种跳转方式
            goToDetail(item) {
                //this.$router.push({path:'/news2', query: {id: item.id}});
                const url = `/news?id=${encodeURIComponent(item.id)}`;
                this.$router.push(url, () => {
                    // 导航完成后滚动到顶部
                    window.scrollTo(0, 0);
                }, (error) => {
                    // 可选：处理导航失败的情况
                    console.error('导航失败:', error);
                });

            },
            goToMore(url) {
                // 新标签页打开方式
                window.open(url, '_blank');
            },
            getInfo(){
                this.newsList = [];
                let query ={code:'xwzx',pageNum:this.currentPage,pageSize:6,type:this.type};
                this.$HTTP.getNewsList(query).then(resp => {
                    if(resp.code == 200){
                        let data = resp.data;
                        let dataList =data.newPage.list;
                        this.newsList = dataList.map(item=>{
                            item.publishTime = formartDate(item.publishTime)
                            return item;
                        });
                        this.totalCount = data.newPage.total;
                    }
                });
            },
        }
    };
</script>
<style scoped lang="css" src="./css/index.css" />
